<template>
  <b-modal
    ref="valueModal"
    size="md"
    hide-footer
    :title="$t('diagnosis.labels.workUnitInfo')"
    centered
    modal-class="work-modal"
  >
    <b-row class="mx-1">
      <b-col>
        <div class="info-card d-flex flex-column justify-content-center align-items-center">
          <small>{{ $t('diagnosis.labels.workUnitCase') }}</small>
          <span><strong>{{ totalUCL || 0 }}</strong></span>
        </div>
      </b-col>
    </b-row>
    <b-row class="mx-1">
      <b-col>
        <hr>
      </b-col>
    </b-row>
    <div class="scroll-unit">
      <b-row class="mx-1 sticky">
        <b-col>
          <div class="header p-1">
            <b-row>
              <b-col cols="2" />
              <b-col>
                <span>{{ $t('diagnosis.sections.microscopy') }}</span>
              </b-col>
              <b-col>
                <span>{{ $t('diagnosis.sections.macroscopy') }}</span>
              </b-col>
              <b-col>
                <span>{{ $t('diagnosis.labels.molecular') }}</span>
              </b-col>
              <b-col>
                <span>{{ $t('diagnosis.labels.electronMicro') }}</span>
              </b-col>
              <b-col>
                <span><strong>{{ $t('diagnosis.modals.total') }}</strong></span>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-for="(workUnit, index) in workUnits"
        :key="index"
        class="mx-1 mt-1"
      >
        <b-col>
          <div class="unit-row p-1">
            <b-row>
              <b-col cols="2">
                <span class="ml-3 main"><strong>{{ workUnit.samplenumber }}</strong></span>
              </b-col>
              <b-col>
                <span>{{ workUnit.sampleMicroUcl }}</span>
              </b-col>
              <b-col>
                <span>{{ workUnit.sampleMacroUcl }}</span>
              </b-col>
              <b-col>
                <span>{{ workUnit.sampleSubportionMolecularUcl }}</span>
              </b-col>
              <b-col>
                <span>{{ workUnit.sampleSubportionElectronMicroscopyUcl }}</span>
              </b-col>
              <b-col>
                <span><strong>{{ workUnit.totalSampleUcl }}</strong></span>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

import valuableConceptResource from '@/api/resources/ValuableConceptResource'

export default {
    name: 'WorkUnitModal',
    props: {
        laboratoryId: Number,
        caseId: Number,
        totalUCL: Number
    },
    data() {
        return {
            workUnits: []
        }
    },
    methods: {
        async show() {
            this.updateLoading(true)
            const [err, response] = await this.toCall(valuableConceptResource.findUCLValuableConceptAppliedByCase(this.laboratoryId, this.caseId))
            this.updateLoading(false)

            if (err) {
                this.showErrorModalGlobal()
                return
            }

            this.workUnits = response
            this.$refs.valueModal.show()
        },
        hide() {
            this.$refs.valueModal.hide()
        }
    }
}
</script>

<style lang="scss">
.work-modal .main{
  color: vt-color(primary) !important;
}

.work-modal .modal-body{
  padding-bottom: 40px;
}

.work-modal .table-bordered thead th,
.table-bordered thead td {
  font-weight: normal;
  text-transform: uppercase;
  font-size: font-size(small);
  color: vt-color(base-text);
}

.work-modal .info-card {
  border: 1px solid vt-color(light-grey);
  height: 60px;
  line-height: 16px;
  box-shadow: 0 2px 5px 0 #9c9c9c;
}

.work-modal .info-card small {
  text-transform: uppercase;
  font-size: font-size(very-tiny);
}

.work-modal .info-card span {
  color: vt-color(dark-text);
  font-size: font-size(normal);
  text-align: center;
}

.work-modal .header{
  background: vt-color(light-grey-alt);
  border-radius: 3px;
}

.work-modal .header span{
  text-transform: uppercase;
  font-size: font-size(small);
  color: vt-color(dark-text);
}

.work-modal .unit-row{
  border-bottom: 1px solid vt-color(base-text, .7);
  transition: .4s;
  background-color: vt-color(primary, 1);
}

.work-modal .unit-row:hover{
  background-color: vt-color(primary, .95);
}

.work-modal .scroll-unit{
  min-height: 20vh;
  max-height: 30vh;
  overflow-y: auto;
}

.work-modal .sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
}

</style>
